// removed by extract-text-webpack-plugin
module.exports = {"classPaginationCarousel":"PaginationCarousel-classPaginationCarousel-e62dedd4","classPaginationCarouselButton":"PaginationCarousel-classPaginationCarouselButton-560574aa","classPaginationCarouselActive":"PaginationCarousel-classPaginationCarouselActive-40a191cb"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/PaginationCarousel.scss
// module id = 831
// module chunks = 0